// extracted by mini-css-extract-plugin
module.exports = {"root":"PlaylistDetailsWrapper_root__2kPey"};